import classNames from "classnames";
import React from "react";
import ScrollContainer from "react-indiana-drag-scroll";

import "./Tabs.scss";

export default function Tabs({ tabs, currentTabId, setTab }) {
  return (
    <ScrollContainer className="universal-table-tabs-scroll" horizontal>
      <div className="universal-table-tabs">
        {tabs.map(tab => (
          <div
            className={classNames("universal-table-tab", {
              active: currentTabId === tab.id
            })}
            key={tab.id}
            onClick={() => {
              setTab(tab.id);
            }}
          >
            {tab.name}
          </div>
        ))}
      </div>
    </ScrollContainer>
  );
}
